export { ReactComponent as TableIcon } from './svgs/table.svg';
